"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lib_1 = require("@fuselab/ui-shared/lib");
var defaultPreference = { compact: false, theme: 'light' };
function loadPreference() {
    // tslint:disable:no-cookies
    var preferenceJSON = lib_1.parseCookie(document.cookie).preference || JSON.stringify(defaultPreference);
    return JSON.parse(preferenceJSON);
}
exports.loadPreference = loadPreference;
//# sourceMappingURL=preference.js.map